module.exports = __webpack_public_path__ + "img/label-mc-nb1.5e05049d.png";